import { $t } from "@/i18n";

export default function maybeTranslateCommonTerm(term: string): string {
  switch (term) {
    case "Dossier":
      return $t("common.label.dossier");
    case "Contacts":
      return $t("common.label.contacts");
    case "Projects":
      return $t("common.label.projects");
    case "Files":
      return $t("common.label.filesModule");
    case "Accounting":
      return $t("common.label.accounting");
    case "Assets":
      return $t("common.label.assets");
    case "Products":
      return $t("common.label.products");
    default:
      return term;
  }
}
